import React from "react";
import "./SobreNos.css";

const SobreNos = () => {
  return (
    <section className="sobre-container">
      <h1 className="sobre-titulo">Conheça nossa empresa</h1>

      <div className="sobre-box">
        <h2 className="sobre-nome">LORETECH.LS</h2>
        <hr className="sobre-linha" />

        <p className="sobre-texto">
          A Loretech.ls é uma empresa inovadora, para soluções tecnológicas para
          alavancar sua empresa e seu negócio.
        </p>

        <p className="sobre-texto">
          O maior objetivo e criar sua identidade visual e deixar seu site,
          moderno e atrativo para você e seus cliente.
        </p>

        <p className="sobre-texto">
          Nossos serviços oferecem que todas as suas redes sociais e comerciais,
          junto com o seu site fique com sua identidade visual e a sua marca
          registrada.
        </p>

        <p className="sobre-texto">
          A paixão que temos pela a tecnologia é o que nos move, todos os dias
          nos dedicamos para que possamos ver nossos clientes feliz e
          satisfeitos e com a sua marca e identidade alavancada no mercado.
        </p>

        {/* ÍCONES COM LINKS */}
        <div className="sobre-icons">
          {/* Instagram */}
          <a
            href="https://instagram.com/loretechls"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/5511988833017"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21.05 11.1a8.94 8.94 0 1 1-16.88-3.3L3 3l4.8.93a8.94 8.94 0 0 1 13.25 7.17z"></path>
              <path d="M8 12l2 1 1-1 2 1 3-3"></path>
            </svg>
          </a>

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/in/lorena-santos--"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="9" width="4" height="12"></rect>
              <circle cx="4" cy="4" r="2"></circle>
              <path d="M8 9h4v12H8z"></path>
              <path d="M12 13h4v8h-4z"></path>
              <path d="M16 13h4v8h-4z"></path>
            </svg>
          </a>

          {/* Email */}
          <a
            href="loretechls@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 4h16v16H4z"></path>
              <polyline points="4,4 12,12 20,4"></polyline>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SobreNos;
